import { render, staticRenderFns } from "./GraficoSpiderWebTotalConjuntos.vue?vue&type=template&id=741dfaaa&"
import script from "./GraficoSpiderWebTotalConjuntos.vue?vue&type=script&lang=js&"
export * from "./GraficoSpiderWebTotalConjuntos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
